import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { Action } from 'redux';
import { AsyncAction } from 'redux-promise-middleware';

export const API_PATH_LOGS = '/logs';
export const API_PATH_EXPORT_LOGS = `${API_PATH_LOGS}/export`;
export const API_PATH_FILTER_OPTIONS = 'log-filter-options';

export const FETCH_LOGS = 'FETCH_LOGS';
export const FETCH_LOGS_PENDING = 'FETCH_LOGS_PENDING';
export const FETCH_LOGS_FULFILLED = 'FETCH_LOGS_FULFILLED';
export const FETCH_LOGS_REJECTED = 'FETCH_LOGS_REJECTED';

export const FETCH_LOGS_FILTER_OPTIONS = 'FETCH_LOGS_FILTER_OPTIONS';
export const FETCH_LOGS_FILTER_OPTIONS_PENDING =
  'FETCH_LOGS_FILTER_OPTIONS_PENDING';
export const FETCH_LOGS_FILTER_OPTIONS_FULFILLED =
  'FETCH_LOGS_FILTER_OPTIONS_FULFILLED';
export const FETCH_LOGS_FILTER_OPTIONS_REJECTED =
  'FETCH_LOGS_FILTER_OPTIONS_REJECTED';

export const EXPORT_LOGS = 'EXPORT_LOGS';
export const EXPORT_LOGS_PENDING = 'EXPORT_LOGS_PENDING';
export const EXPORT_LOGS_FULFILLED = 'EXPORT_LOGS_FULFILLED';
export const EXPORT_LOGS_REJECTED = 'EXPORT_LOGS_REJECTED';

export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS';

export interface OpenSearchLogDTO {
  index: string;
  id: string;
  score: number;
  timestamp: string;
  sourceFileName: string;
  sourceLineNum: string;
  processName: string;
  severity: string;
  message: string;
}

export interface GetOpenSearchLogFilterValuesDTO {
  processNames: OpenSearchFilterOptionDTO[];
  severities: OpenSearchFilterOptionDTO[];
  hostnames: OpenSearchFilterOptionDTO[];
  clusternames: OpenSearchFilterOptionDTO[];
}

export interface OpenSearchFilterOptionDTO {
  key: string;
  documentCount: number;
}

export interface OpenSearchLogFilterCriteriaDTO {
  dateRange: Date[];
  processNames: string[];
  severities: string[];
  hostnames: string[];
  clusternames: string[];
  textSearch: string;
}

export interface FetchLogsAction extends AsyncAction {
  type: typeof FETCH_LOGS;
  payload: AxiosPromise<ServerResponse<OpenSearchLogDTO>>;
}

export interface FetchLogsFulfilledAction extends Action {
  type: typeof FETCH_LOGS_FULFILLED;
  payload: AxiosResponse<ServerResponse<OpenSearchLogDTO>>;
}

export interface FetchLogsFilterOptionsAction extends AsyncAction {
  type: typeof FETCH_LOGS_FILTER_OPTIONS;
  payload: AxiosPromise<ServerResponse<GetOpenSearchLogFilterValuesDTO>>;
}

export interface FetchLogsFilterOptionsFulfilledAction extends Action {
  type: typeof FETCH_LOGS_FILTER_OPTIONS_FULFILLED;
  payload: AxiosResponse<ServerResponse<GetOpenSearchLogFilterValuesDTO>>;
}

export interface ExportLogsAction extends AsyncAction {
  type: typeof EXPORT_LOGS;
  payload: AxiosPromise<BlobPart>;
}

export interface SetFilterOptionsAction extends Action {
  type: typeof SET_FILTER_OPTIONS;
  payload: GetOpenSearchLogFilterValuesDTO;
}

export interface LogState {
  logs: OpenSearchLogDTO[];
  processNameFilterOptions: OpenSearchFilterOptionDTO[];
  severityFilterOptions: OpenSearchFilterOptionDTO[];
  hostnameOptions: OpenSearchFilterOptionDTO[];
  clusternameOptions: OpenSearchFilterOptionDTO[];
}

export type LogActionTypes =
  | FetchLogsAction
  | FetchLogsFulfilledAction
  | FetchLogsFilterOptionsAction
  | FetchLogsFilterOptionsFulfilledAction
  | SetFilterOptionsAction
  | ExportLogsAction;
